import React from 'react';
import { HomeExpired } from './HomeExpired';
import { UserContextType } from '../user/user.types';
import { doctrineAnalytics } from '../utils/analyticsUtils';
import { withUser } from '../user/UserContext';

type Props = UserContextType;

type State = {
  called: boolean;
};

export class RawHomeExpiredWrapper extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    doctrineAnalytics('Account TrialExpiredAppeared');

    const { currentUser } = props;
    this.isContacted = currentUser.expirationDate !== currentUser.origExp;
  }

  state: State = {
    called: false,
  };

  onCall = () => {
    const { isIcp } = this.props.currentUser;
    this.setState({ called: true });
    // Salesforce event: do not modify without consultation
    doctrineAnalytics('Home EndTrialCallNow', {
      is_icp: isIcp,
      is_icp_and_verified: isIcp && this.isContacted,
    });
  };

  onContact = () => {
    window.Intercom('show');
  };

  isContacted: boolean;

  render() {
    const { isIcp } = this.props.currentUser;
    return (
      <HomeExpired
        phoneNumber={this.props.currentUser.phoneNumber}
        isIcp={isIcp}
        isContacted={this.isContacted}
        hasCalled={this.state.called}
        onCall={this.onCall}
        onContact={this.onContact}
      />
    );
  }
}

export const HomeExpiredWrapper = withUser(RawHomeExpiredWrapper);
